import List from "@/components/list";

const Table = (args) => {
  const { listeners, props } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  const download = listeners["download"] || function() {};

  const Deal = ({ props: { vo } }) => {
    const { row } = vo;
    return (
      <div class="deal-group">
        {
          row.fileId && row.fileId.length > 0 ? (
            // <el-button type="text" v-permission="enroll:downloadTransferFile" onClick={() => download(row)}>下载</el-button>
            <el-tooltip content="下载" placement="top" v-permission="enroll:downloadTransferFile">
              <i class="iconfont ic_download iconfont-adapt" onClick={() => download(row)}></i>
            </el-tooltip>
          ) : (
            <span>--</span>
          )
        }
      </div>
    );
  }

  // const selectable = row => {    
  //   return row.fileId && row.fileId.length > 0;
  // };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
      // selectable: selectable
    },
    {
      label: "姓名",
      prop: "userName",
      minWidth: "80",
      showOverflowTooltip: true
    },
    {
      label: "工作单位",
      prop: "deptName",
      minWidth: "200",
      showOverflowTooltip: true
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "200",
      showOverflowTooltip: true
    },
    {
      label: "选调函",
      prop: "fileName",
      minWidth: "110",
      showOverflowTooltip: true
    },
    {
      label: "联络员",
      prop: "liaisonName",
      minWidth: "80",
      showOverflowTooltip: true
    },
    {
      label: "联络员手机号",
      prop: "liaisonMobile",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "签收状态",
      prop: "signStatusName",
      minWidth: "90",
      showOverflowTooltip: true
    },
    {
      label: "签收时间",
      prop: "signTime",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "发布时间",
      prop: "publishTime",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "操作",
      minWidth: "60",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ]
  return <List {...args}
               onSelectionChange={RCSelectionChange}
               talbeCols={AccountTableConfig} />;
}
export default Table;
    